<template>
  <div ref="goc" class="bd">
    <canvas ref="cv" :style="{ height: cao + 'px' }" @mousemove="dichChuot" @mouseleave="di = -1" />
    <div v-if="di >= 0 && tip" class="bd-tip" :style="{ left: tip.x + 'px' }">
      <div class="bd-tip-gio">{{ tip.gio }}</div>
      <div v-for="d in tip.dong" :key="d.ten" class="bd-tip-dong">
        <i :style="{ background: d.mau }" /> {{ d.ten }}: <b>{{ d.v }}</b>
      </div>
    </div>
    <div class="bd-chuthich">
      <span v-for="c in chuoi" :key="c.ten"><i :style="{ background: c.mau }" />{{ c.ten }}</span>
    </div>
    <div v-if="!coDuLieu" class="bd-rong">{{ lang('Đang thu thập số liệu...') }}</div>
  </div>
</template>

<script>
// Bieu do duong ve bang canvas, khong dung thu vien ngoai. Tu co gian theo be rong, ve lai khi
// du lieu doi, di chuot hien chi tiet.
export default {
  name: 'BieuDo',
  props: {
    chuoi: { type: Array, default: () => [] }, // [{ ten, mau, giaTri: [] }]
    thoiGian: { type: Array, default: () => [] }, // giay unix, cung do dai voi giaTri
    toiDa: { type: Number, default: 0 }, // 0 = tu tinh
    dinhDang: { type: Function, default: v => String(v) },
    cao: { type: Number, default: 170 },
    to: { type: Boolean, default: true },
  },
  data() {
    return { di: -1, tip: null }
  },
  computed: {
    coDuLieu() {
      return this.thoiGian.length > 1
    },
  },
  watch: {
    chuoi: { deep: true, handler() { this.$nextTick(this.ve) } },
    thoiGian() { this.$nextTick(this.ve) },
    di() { this.$nextTick(this.ve) },
  },
  mounted() {
    this.ve()
    window.addEventListener('resize', this.ve)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.ve)
  },
  methods: {
    khung() {
      return { trai: this.traiDo || 52, phai: 10, tren: 10, duoi: 22 }
    },
    soDep(v) {
      if (v <= 0) return 1
      const m = Math.pow(10, Math.floor(Math.log10(v)))
      const n = v / m
      return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 2.5 ? 2.5 : n <= 5 ? 5 : 10) * m
    },
    gioNhan(t, dai) {
      const d = new Date(t * 1000)
      const p = x => (x < 10 ? '0' : '') + x
      const khoang = this.thoiGian.length ? this.thoiGian[this.thoiGian.length - 1] - this.thoiGian[0] : 0
      // Khoang ngan (thoi gian thuc, vai phut) can hien ca giay, neu khong cac moc trung nhau
      return (dai ? p(d.getDate()) + '/' + p(d.getMonth() + 1) + ' ' : '') + p(d.getHours()) + ':' + p(d.getMinutes()) + (khoang <= 900 ? ':' + p(d.getSeconds()) : '')
    },
    ve() {
      const cv = this.$refs.cv
      if (!cv) return
      const rong = this.$refs.goc.clientWidth
      const dpr = window.devicePixelRatio || 1
      cv.width = rong * dpr
      cv.height = this.cao * dpr
      const g = cv.getContext('2d')
      g.setTransform(dpr, 0, 0, dpr, 0, 0)
      g.clearRect(0, 0, rong, this.cao)
      const n = this.thoiGian.length
      if (n < 2) return

      let max = this.toiDa
      if (!max) {
        let m = 0
        this.chuoi.forEach(c => c.giaTri.forEach(v => { if (v > m) m = v }))
        max = this.soDep(m * 1.1)
      }
      // Be rong le trai theo nhan dai nhat (vd "58.99 MB/s") de khong bi cat
      g.font = '11px sans-serif'
      let dai = 0
      for (let k = 0; k <= 4; k++) dai = Math.max(dai, g.measureText(this.dinhDang((max * k) / 4)).width)
      this.traiDo = Math.max(44, Math.ceil(dai) + 14)
      const { trai, phai, tren, duoi } = this.khung()
      const w = rong - trai - phai
      const h = this.cao - tren - duoi
      const mauChu = getComputedStyle(this.$refs.goc).color
      const x = i => trai + (w * i) / (n - 1)
      const y = v => tren + h - (h * Math.min(v, max)) / max

      g.font = '11px sans-serif'
      g.textBaseline = 'middle'
      g.lineWidth = 1
      for (let k = 0; k <= 4; k++) {
        const v = (max * k) / 4
        const yy = Math.round(y(v)) + 0.5
        g.strokeStyle = 'rgba(127,140,160,0.25)'
        g.beginPath(); g.moveTo(trai, yy); g.lineTo(rong - phai, yy); g.stroke()
        g.fillStyle = mauChu
        g.globalAlpha = 0.7
        g.textAlign = 'right'
        g.fillText(this.dinhDang(v), trai - 6, yy)
        g.globalAlpha = 1
      }
      const nhieuNgay = this.thoiGian[n - 1] - this.thoiGian[0] > 86400 * 1.5
      g.textAlign = 'center'
      g.textBaseline = 'top'
      // So moc gio tu giam khi bieu do hep de cac nhan khong de len nhau
      const soNhan = Math.max(2, Math.min(5, Math.floor(w / 85) + 1))
      for (let k = 0; k < soNhan; k++) {
        const i = Math.round(((n - 1) * k) / (soNhan - 1))
        g.fillStyle = mauChu
        g.globalAlpha = 0.7
        g.fillText(this.gioNhan(this.thoiGian[i], nhieuNgay), Math.min(Math.max(x(i), trai + 22), rong - phai - 22), tren + h + 5)
        g.globalAlpha = 1
      }

      this.chuoi.forEach(c => {
        if (!c.giaTri.length) return
        g.beginPath()
        c.giaTri.forEach((v, i) => { i ? g.lineTo(x(i), y(v || 0)) : g.moveTo(x(i), y(v || 0)) })
        g.strokeStyle = c.mau
        g.lineWidth = 2
        g.lineJoin = 'round'
        g.stroke()
        if (this.to && !c.khongTo) {
          g.lineTo(x(c.giaTri.length - 1), tren + h)
          g.lineTo(x(0), tren + h)
          g.closePath()
          const gr = g.createLinearGradient(0, tren, 0, tren + h)
          gr.addColorStop(0, c.mau + '55')
          gr.addColorStop(1, c.mau + '08')
          g.fillStyle = gr
          g.fill()
        }
      })

      if (this.di >= 0 && this.di < n) {
        const xx = Math.round(x(this.di)) + 0.5
        g.strokeStyle = 'rgba(127,140,160,0.7)'
        g.lineWidth = 1
        g.beginPath(); g.moveTo(xx, tren); g.lineTo(xx, tren + h); g.stroke()
        this.chuoi.forEach(c => {
          if (c.giaTri[this.di] === undefined) return
          g.beginPath()
          g.arc(x(this.di), y(c.giaTri[this.di] || 0), 4, 0, Math.PI * 2)
          g.fillStyle = c.mau
          g.fill()
          g.strokeStyle = '#fff'
          g.lineWidth = 1.5
          g.stroke()
        })
      }
    },
    dichChuot(e) {
      const n = this.thoiGian.length
      if (n < 2) return
      const { trai, phai } = this.khung()
      const rong = this.$refs.goc.clientWidth
      const r = this.$refs.cv.getBoundingClientRect()
      const px = e.clientX - r.left
      const i = Math.max(0, Math.min(n - 1, Math.round(((px - trai) / (rong - trai - phai)) * (n - 1))))
      this.di = i
      const dai = this.thoiGian[n - 1] - this.thoiGian[0] > 86400 * 1.5
      this.tip = {
        x: Math.min(Math.max(px + 12, 8), rong - 170),
        gio: this.gioNhan(this.thoiGian[i], dai),
        dong: this.chuoi.map(c => ({ ten: c.ten, mau: c.mau, v: this.dinhDang(c.giaTri[i] || 0) })),
      }
    },
  },
}
</script>

<style scoped>
.bd { position: relative; width: 100%; }
.bd canvas { display: block; width: 100%; }
.bd-chuthich { display: flex; flex-wrap: wrap; gap: 0.9rem; font-size: 0.78rem; margin-top: 0.3rem; opacity: 0.85; }
.bd-chuthich i, .bd-tip i { display: inline-block; width: 10px; height: 10px; border-radius: 3px; margin-right: 5px; }
.bd-tip { position: absolute; top: 6px; z-index: 5; pointer-events: none; background: rgba(30, 36, 48, 0.92); color: #fff; border-radius: 8px; padding: 6px 10px; font-size: 0.78rem; min-width: 140px; }
.bd-tip-gio { opacity: 0.7; margin-bottom: 2px; }
.bd-rong { position: absolute; left: 0; right: 0; top: 40%; text-align: center; opacity: 0.6; font-size: 0.85rem; }
</style>
